import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ClientMenu from "../../components/clientMenu/ClientMenu";
import ContractEdit from "../../components/contractEdit/ContractEdit";
import ContractTap from "../../components/contractTap/ContractTap";
import ContractList from "../../components/contractList/ContractList";

const ClientEditPage = () => {
  const navigate = useNavigate();
  let { clientId, contractId } = useParams();
  const [tapSelected, setTapSelected] = useState(1);

  const handleChangeTap = (tapNumber) => {
    setTapSelected(tapNumber);
  };

  const handleBackCustomer = () => {
    return navigate(-1);
  };

  return (
    <>
      <ClientMenu>
        <ContractTap
          tapSelected={tapSelected}
          handleChangeTap={handleChangeTap}
          clientId={clientId}
          contractId={contractId}
          handleBackCustomer={handleBackCustomer}
        />
        {tapSelected === 1 && <ContractEdit contractId={contractId} />}
        {tapSelected === 2 && <ContractList />}
      </ClientMenu>
    </>
  );
};

export default ClientEditPage;
